import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/AddSelectedInfluencers.graphql';
import { Mutation, MutationaddSelectedInfluencersArgs } from '../../__generated__/globalTypes';

export const useAddSelectedInfluencersMutation = (
  options?: MutationHookOptions<Mutation, MutationaddSelectedInfluencersArgs>
) => {
  const [callAddSelectedInfluencers, result] = useMutation<Mutation, MutationaddSelectedInfluencersArgs>(
    MUTATION,
    options
  );

  return { callAddSelectedInfluencers, ...result };
};

export type AddSelectedInfluencersMutationFunction = Mutation['addSelectedInfluencers'];
